export const initialState = {
	kunjungan: {
		status: true,
		message: "",
		data: [],
		count: "",
		sisa: "",
		limit: "",
		pages: "",
	},
};

export const actions = {
	CHANGE_KUNJUNGAN: "CHANGE_KUNJUNGAN",
	CHANGE_LOADING: "CHANGE_LOADING",
};
